import React, { useEffect, useState, useContext } from "react";
import "./ToolBarLeftPanel.scss";

import expandIcon from '../../images/leftArrow.svg';
import checkMarkGreen from "../../images/CheckmarkGreen.svg";
import AssociatedCard from "./AssociatedCard";
import ValueContext from "../../utils/contextAPI/contextAPI";
import { getVeevaLinkedModulesListByid } from "../../services/apis";


const AssociatedModules = ({
  selectedModule,
  setSelectedModule,
  moduleClaimsData,
  sendAtomDetails2Canvas,
  customDrag,
  editor
}) => {
  const [expandModule, setExpandModule] = useState([]);
  const [expand, setExpand] = useState([]);
  const [currentModule, setCurrentModule] = useState(0);
    const [modulesList, setModulesList] = useState(null)
  
  const appData = useContext(ValueContext);
  useEffect(() => {
    const anyExpanded = expandModule.some((item) => item === true);
    setExpand(anyExpanded);
  }, [expandModule]);

  useEffect(() => {
    setExpandModule([]);
    setExpand(false);
  }, [currentModule]);

  useEffect(() => {
    getModules();
  },[])

  const getModules=()=>{ 
            // console.log('eee----', appData);
            // appData.setDeckId({ ...appData?.deckId, _id: edetailId });
            getVeevaLinkedModulesListByid(appData?.deckId?._id, (response, err, errorCode) => {
              if (err) {
             
              }
              else {
                console.log("called modules", response.data.response.content_modules)
                setModulesList(response.data.response.content_modules);
                
              }
            });
  }
  
  return (
    <>
      <div className="selected-module-window ">
        <div className="buissness-rule-div">
          <img
            src={expandIcon}
            onClick={() => setSelectedModule(undefined)}
            className="expandIcon-module" 
          />
          <div style={{ paddingLeft: "7px" }} className="infoText">
            Module
          </div>
          <div style={{ paddingLeft: "4px" }}>:</div>
          <img src={checkMarkGreen} className="check-mark-green" />
          <strong className="boldText">
            {selectedModule?.module_name||
              selectedModule?.targetModuleDamName}
          </strong>
        </div>
        <div className="note-text mb-3 mt-1">
          {/* {expand ? "Note: All claims below are approved for use." : ""} */}
          Note: All claims below are approved for use.
        </div>
        <div className="must-use-div mb-3">
          <div
            className="parentModulebox"
            style={{ backgroundColor: "#E32B35" }}
          ></div>
          <div className="rulesText">Must use</div>
          <div
            className="parentModulebox"
            style={{ backgroundColor: "#378A05", marginLeft: "12px" }}
          ></div>
          <div className="rulesText">Optional</div>
        </div>{" "}
        <div className="switch-section-div">
          <div
            className="section-change"
            style={{
              borderBottom: currentModule === 0 ? "2px solid #203662" : "",
              color: currentModule === 0 ? "#203662" : "#54565c",
              fontWeight: currentModule === 0 ? "600" : "",
            }}
            onClick={() => setCurrentModule(0)}
          >
            {`Claims (${
              moduleClaimsData?.claims?.length > 0
                ? moduleClaimsData?.claims?.length
                : 0
            })`}
          </div>
          <div
            className="section-change"
            style={{
              borderBottom: currentModule === 1 ? "2px solid #203662" : "",
              color: currentModule === 1 ? "#203662" : "#54565c",
              fontWeight: currentModule === 1 ? "600" : "",
            }}
            onClick={() => setCurrentModule(1)}
          >
            {`Reusable Text (${
              moduleClaimsData?.reusableTexts?.length > 0
                ? moduleClaimsData?.reusableTexts?.length
                : 0
            })`}
          </div>
          <div
            className="section-change"
            style={{
              borderBottom: currentModule === 2 ? "2px solid #203662" : "",
              color: currentModule === 2 ? "#203662" : "#54565c",
              fontWeight: currentModule === 2 ? "600" : "",
            }}
            onClick={() => setCurrentModule(2)}
          >
            {`Component (${
              moduleClaimsData?.components?.length > 0
                ? moduleClaimsData?.components?.length
                : 0
            })`}
          </div>
        </div>
        <div
          style={{
            width: "100%",
            backgroundColor: "#DDDFDD",
            height: "0.5px",
          }}
        ></div>
        <div className="mt-2 custonScrollBar modulesCliamsection">
          {currentModule === 0 && (
            <>
              {moduleClaimsData?.claims?.map((claim, index) => {
                return (
                  <AssociatedCard
                    modulesArray={moduleClaimsData?.claims}
                    claim={claim}
                    expandModule={expandModule}
                    setExpandModule={setExpandModule}
                    sendAtomDetails2Canvas={sendAtomDetails2Canvas}
                    customDrag={customDrag}
                    index={index}
                    editor={editor}
                    moduleClaimsData={moduleClaimsData}
                    modulesList={modulesList}
                  />
                );
              })}
            </>
          )}
          {currentModule === 1 && (
            <>
              {moduleClaimsData?.reusableTexts?.map((reusableText, index) => {
                return (
                  <AssociatedCard
                    modulesArray={moduleClaimsData?.reusableTexts}
                    reusableText={reusableText}
                    expandModule={expandModule}
                    setExpandModule={setExpandModule}
                    sendAtomDetails2Canvas={sendAtomDetails2Canvas}
                    customDrag={customDrag}
                    index={index}
                    editor={editor}
                  />
                );
              })}
            </>
          )}
          {currentModule === 2 && (
            <>
              {moduleClaimsData?.components?.map((component, index) => {
                return (
                  <AssociatedCard
                    modulesArray={moduleClaimsData?.components}
                    component={component}
                    expandModule={expandModule}
                    setExpandModule={setExpandModule}
                    sendAtomDetails2Canvas={sendAtomDetails2Canvas}
                    customDrag={customDrag}
                    index={index}
                    editor={editor}
                  />
                );
              })}
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default AssociatedModules;
